<template>
  <div>
    <v-card class="pa-5">
      <v-card-title>
        <v-spacer/>
        <v-form lazy-validation ref="searchValidation">
          <v-text-field
            style="max-width: 250px"
            dense
            outlined
            clearable
            :placeholder="$t('general.search')"
            v-model="search"
            append-icon="search"
            hide-details
            class="mr-2"
            :rules="rules.textNoSpecialChars"
            @keyup.enter="searching"
            @click:append="searching"
          />
        </v-form>
        <!-- <v-btn
          color="primary"
          to="/unit-types/add">
          {{$t('unitTypes.add')}}
        </v-btn> -->
      </v-card-title>
      <v-card-text>
        <v-overlay absolute opacity="0" :value="loadingTable"/>
        <v-data-table
          :loading="loadingTable"
          :loading-text="$t('general.loading')"
          :search="search"
          :headers="headers"
          :items="unitTypes"
          :options.sync="options"
          :footer-props="{ 'items-per-page-options': [15, 25, 50] }"
          :server-items-length="options.total"
          @update:page="get"
          @update:items-per-page="get"
          @update:sort-by="get"
          @update:sort-desc="get"
        >
        <template v-slot:item.actions="{ item }">
          <v-icon
            small
            class="mr-2"
            @click="editItem(item)"
          >
            far fa-edit
          </v-icon>
          <v-icon
            small
            class="mr-2"
            @click="showDelete(item)"
          >
            far fa-trash-alt
          </v-icon>
        </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog
      v-model="deleteDialog"
      width="500"
    >
      <v-card>
        <v-card-title
          class="error--text grey lighten-5"
        >
          {{$t('unitTypes.delete')}}
        </v-card-title>

        <v-card-text class="pt-5">
          <span>{{$t('unitTypes.delMessage')}}</span> <span class="font-weight-bold">{{item.name}}</span> ?
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            outlined
            @click="deleteDialog = false"
          >
           {{$t('general.cancel')}}
          </v-btn>
          <v-btn
            color="error"
            @click="deleteType"
          >
           {{$t('general.delete')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      deleteDialog: false,
      loadingTable: true,
      search: '',
      item: {
        id: 0,
        name: ''
      },
      options: {
        itemsPerPage: 15,
        page: 1,
        total: 0
      },
      unitTypes: [],
      new: false,
      idEdit: 0,
    }
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t('general.name'),
          align: 'center',
          value: 'alias',
        },
        // {
        //   text: this.$t('general.actions'),
        //   align: 'center',
        //   value: 'actions',
        //   sortable: false
        // }
      ]
    },
    rules () {
      return this.$validationRules()
    }
  },
  watch: {
    search (val) {
      if (val === '' || val === null) this.searching()
    }
  },
  created () {
    if(this.$route.path === '/unit-types/add') {
      this.new = true
    } else {
      this.idEdit = this.$route.params.id
    }
    this.get()
  },
  methods: {
    editItem (item) {
      this.$router.push('/unit-types/edit/' + item.id)
    },
    showDelete (item) {
      this.item = item
      this.deleteDialog = true
    },
    deleteType () {
      this.$store.dispatch('unitTypes/delete', {
        event: {
          context: this,
          id: this.item.id
        }
      })
      this.deleteDialog = false
    },
    searching () {
      if(this.search && !this.$refs.searchValidation.validate()) return this.showNotification(this.$t('validation.noSpecialChars'), 'warn', -1)
    
      this.$refs.searchValidation.resetValidation()
      
      this.options.page = 1,
      this.options.perPage = 5
      this.get()
    },
    get () {
      this.loadingTable = true
      
      this.$store.dispatch('unitTypes/get', {
        event: {
          perPage: this.options.itemsPerPage,
          page: this.options.page,
          sortKey: (this.options.sortBy && this.options.sortBy.length > 0) ? this.options.sortBy[0] : 'alias',
          ord: this.options.sortDesc && this.options.sortDesc[0] ? 'asc' : 'desc',
          find: this.search,
          context: this
        }
      })
    }
  }
}
</script>